import { DEFAULT_LOYALTY_LEVEL_NAME, LOYALTY_LEVEL_COLORS } from '../../constants/levelColors'
import { LOYALTY_LEVEL_NAMES } from '../../constants/levelNames'
import { LoyaltyLevelColorsInterface } from '../../types'

export const getLevelColors = (levelName?: string): LoyaltyLevelColorsInterface =>
  LOYALTY_LEVEL_COLORS[levelName as LOYALTY_LEVEL_NAMES] ?? LOYALTY_LEVEL_COLORS[DEFAULT_LOYALTY_LEVEL_NAME]
